import {
  GetHubLastVisitedQuery,
  GetHubLastVisitedQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { useAuthenticatedUserContext } from '@/contexts/user-context';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const GET_HUB_LAST_VISITED_QUERY = gql`
  query GetHubLastVisited($employeeUUID: uuid!) {
    hub_last_visited_by_pk(employee_uuid: $employeeUUID) {
      last_visited_at
    }
  }
`;

export const useHubLastVisited = () => {
  const { user } = useAuthenticatedUserContext();

  const {
    data: lastVisitedData,
    loading: lastVisitedLoading,
    error: lastVisitedError,
  } = useWrappedQuery<GetHubLastVisitedQuery, GetHubLastVisitedQueryVariables>(
    GET_HUB_LAST_VISITED_QUERY,
    {
      fetchPolicy: 'network-only',
      variables: { employeeUUID: user.uuid },
    },
  );

  const lastVisitedAt: string | null =
    lastVisitedData?.hub_last_visited_by_pk?.last_visited_at ?? null;

  return {
    lastVisitedAt,
    lastVisitedError,
    lastVisitedLoading,
  };
};
